export const ActionTypes = {
  REGISTER_CARRIER: "REGISTER_CARRIER",
  LOGIN_CARRIER: "LOGIN_CARRIER",
  BUSINESS_NAME: "BUSINESS_NAME",
  CREATE_CARRIER: "CREATE_CARRIER",
  CREATE_RATES: "CREATE_RATES",
  UPDATE_RATES: "UPDATE_RATES",
  GET_RATES_BY_CARRIER_ID: "GET_RATES_BY_CARRIER_ID",
  SEND_LOGO: "SEND_LOGO",
  GET_CARRIER: "GET_CARRIER",
  GET_Rate: "GET_Rate",
  CREATE_BOX_RATES: "CREATE_BOX_RATES",
  UPDATE_BOX_RATES: "UPDATE_BOX_RATES",
  GET_BOX_Rate: "GET_BOX_Rate",
  CREATE_INSURANCE: "CREATE_INSURANCE",
  UPDATE_INSURANCE: "UPDATE_INSURANCE",
  GET_INSURANCE: "GET_INSURANCE",
  CREATE_TIME_SLOT: "CREATE_TIME_SLOT",
  UPDATE_TIME_SLOT: "UPDATE_TIME_SLOT",
  GET_TIME_SLOT: "GET_TIME_SLOT",
  DELETE_TIME_SLOT: "DELETE_TIME_SLOT",
  CREATE_TRAVEL_TIME: "CREATE_TRAVEL_TIME",
  UPDATE_TRAVEL_TIME: "UPDATE_TRAVEL_TIME",
  GET_TRAVEL_TIME: "GET_TRAVEL_TIME",
  CREATE_LONG_DISTANCE: "CREATE_LONG_DISTANCE",
  UPDATE_LONG_DISTANCE: "UPDATE_LONG_DISTANCE",
  GET_LONG_DISTANCE: "GET_LONG_DISTANCE",
  DELETE_LONG_DISTANCE: "DELETE_LONG_DISTANCE",
  GET_CARRIER_MOVES: "GET_CARRIER_MOVES",
  GET_CARRIER_MOVES_LIMITED: "GET_CARRIER_MOVES_LIMITED",
  GET_CARRIER_MOVES_BY_DWELLING: "GET_CARRIER_MOVES_BY_DWELLING",
  GET_CARRIER_MOVES_COUNT: "GET_CARRIER_MOVES_COUNT",
  GET_CARRIER_MOVES_COUNT_BY_DWELLING: "GET_CARRIER_MOVES_COUNT_BY_DWELLING",
  GET_ANSWER: "GET_ANSWER",
  ADD_KNOWLEDGE: "ADD_KNOWLEDGE",
  GET_ALL_KNOWLEDGE: "GET_ALL_KNOWLEDGE",
  UPDATE_KNOWLEDGE: "UPDATE_KNOWLEDGE",
  DELETE_KNOWLEDGE: "DELETE_KNOWLEDGE",
  FETCH_WEBSITE_CONTENT: "FETCH_WEBSITE_CONTENT",
  CREATE_MOVE_SERVICE: "CREATE_MOVE_SERVICE",
  UPDATE_MOVE_SERVICE: "UPDATE_MOVE_SERVICE",
  GET_INVENTORY_FROM_IMAGE: "GET_INVENTORY_FROM_IMAGE",
  GET_INVENTORY_DATA: "GET_INVENTORY_DATA",
  ADD_INVENTORY_ITEMS: "ADD_INVENTORY_ITEMS",
  GET_MOVE_SERVICE: "GET_MOVE_SERVICE",
  CREATE_USER: "CREATE_USER",
  GET_CARRIER_BY_BUSINESS_NAME: "GET_CARRIER_BY_BUSINESS_NAME",
  UPDATE_INVENTORY_ITEM: "UPDATE_INVENTORY_ITEM",
  DELETE_INVENTORY_ITEM: "DELETE_INVENTORY_ITEM",
  CREATE_CUSTOMER_STRIPE_SESSION: "CREATE_CUSTOMER_STRIPE_SESSION",
  CREATE_STORAGE: "CREATE_STORAGE",
  CREATE_LABOUR_AND_PACKING: "CREATE_LABOUR_AND_PACKING",
  CREATE_JUNK_REMOVAL: "CREATE_JUNK_REMOVAL",
  UPDATE_LABOUR_AND_PACKING: "UPDATE_LABOUR_AND_PACKING",
  CREATE_LOCATION: "CREATE_LOCATION",
  GET_LOCATION: "GET_LOCATION",
  UPDATE_LOCATION: "UPDATE_LOCATION",
  DELETE_LOCATION: "DELETE_LOCATION",
  GET_LABOUR_AND_PACKING: "GET_LABOUR_AND_PACKING",
  GET_JUNK_REMOVAL: "GET_JUNK_REMOVAL",
  CREATE_JUNK_REMOVAL_ITEMS: "CREATE_JUNK_REMOVAL_ITEMS",
  GENERATE_CARRIER_STRIPE_ONBOARDING_SESSION:
    "GENERATE_CARRIER_STRIPE_ONBOARDING_SESSION",
  CREATE_CARRIER_SUBSCRIPTION_SESSION: "CREATE_CARRIER_SUBSCRIPTION_SESSION",
  CREATE_OR_UPDATE_DELIVERY_DETAILS: "CREATE_OR_UPDATE_DELIVERY_DETAILS",
  GENERATE_OTP: "GENERATE_OTP",
  VERIFY_OTP: "VERIFY_OTP",
  SAVE_VOLUME: "SAVE_VOLUME",
  GET_CONSUMER: "GET_CONSUMER",
  GET_USER_BY_PHONE_NUMBER: "GET_USER_BY_PHONE_NUMBER",
  ATTACH_USER_WITH_MOVE: "ATTACH_USER_WITH_MOVE",
  GET_MOVE_SERVICE_BY_PHONE_NUMBER: "GET_MOVE_SERVICE_BY_PHONE_NUMBER",
  REQUEST_PASSWORD_RESET: "REQUEST_PASSWORD_RESET",
  VERIFY_RESET_PASSWORD_OTP: "VERIFY_RESET_PASSWORD_OTP",
  RESET_PASSWORD: "RESET_PASSWORD",
  DELETE_MOVE_SERVICE: "DELETE_MOVE_SERVICE",
  SEND_CANCELLATION_NOTIFICATION: "SEND_CANCELLATION_NOTIFICATION",
  GET_INVENTORY_BY_PHONE: "GET_INVENTORY_BY_PHONE",
  GET_FULL_INVENTORY: "GET_FULL_INVENTORY",
  SEND_FILTERED_INVENTORY: "SEND_FILTERED_INVENTORY",
  SEND_INVENTORY_TEXT: "SEND_INVENTORY_TEXT",
  REDIRECT_TO_INVENTORY: "REDIRECT_TO_INVENTORY",
  FETCH_INVENTORY_FROM_IMAGE: "FETCH_INVENTORY_FROM_IMAGE",
  CREATE_STRIPE_CONNECT_ACCOUNT: "CREATE_STRIPE_CONNECT_ACCOUNT",
  CHECK_USER_EXIST: "CHECK_USER_EXIST",
  CREATE_CUSTOMER: "CREATE_CUSTOMER",
  CREATE_OPPORTUNITY: "CREATE_OPPORTUNITY",
  CREATE_ROOMS: "CREATE_ROOMS",
  ADD_INVENTORY_TO_OPPORTUNITY: "ADD_INVENTORY_TO_OPPORTUNITY",
  SAVE_SMART_MOVING_RESPONSE: "SAVE_SMART_MOVING_RESPONSE",
  CREATE_JOB: "CREATE_JOB",
  CONFIRM_JOB: "CONFIRM_JOB",
  CREATE_LOG_NOTES_OPPORTUNITY: "CREATE_LOG_NOTES_OPPORTUNITY",
  GET_REFERRAL_SOURCE_ID: "GET_REFERRAL_SOURCE_ID",
  GET_BRANCHE_ID: "GET_BRANCHE_ID",
  GET_TARIFF_ID: "GET_TARIFF_ID",
  GET_MOVE_SIZE_ID: "GET_MOVE_SIZE_ID",
  GET_ALL_CARRIERS: "GET_ALL_CARRIERS",
  ADMIN_REGISTER: "ADMIN_REGISTER",
  ADMIN_LOGIN: "ADMIN_LOGIN",
  GET_CARRIER_SUBSCRIPTIONS: "GET_CARRIER_SUBSCRIPTIONS",
  CANCEL_CARRIER_SUBSCRIPTION: "CANCEL_CARRIER_SUBSCRIPTION",
  CALCULATE_BOX_COUNT: "CALCULATE_BOX_COUNT",
  SMART_MOVING_LEAD_ID: "SMART_MOVING_LEAD_ID",
  FETCH_SUPERMOVE_INVENTORY_FROM_IMAGE: "FETCH_SUPERMOVE_INVENTORY_FROM_IMAGE",
  SEND_INVENTORY_TO_SUPERMOVE: "SEND_INVENTORY_TO_SUPERMOVE",
  CHANGE_CARRIER_ACTIVATION_STATUS: "CHANGE_CARRIER_ACTIVATION_STATUS",
};
